import SVG from "react-inlinesvg";

export function getFolder(foldersById, folderId) {
  if (!folderId) {
    return Object.values(foldersById).find((folder) => folder.parent_folder_id === null);
  } else {
    return foldersById[folderId];
  }
}

export function getParents(foldersById, folderId) {
  let parents = [];
  let currentFolderId = folderId;

  while (currentFolderId) {
    const parent = foldersById[currentFolderId];
    parents.unshift(parent);
    if (!parent || parent.parent_folder_id === currentFolderId || parent.deleted) {
      break;
    }
    currentFolderId = parent.parent_folder_id;
  }

  parents.pop();

  return parents;
}

export function getActionsMoveToFolder(foldersById, foldersByParentId, onMoveToFolder, folderId, isProject) {
  const rootFolder = getFolder(foldersById, null);
  const parentFolderId = getFolder(foldersById, folderId)?.parent_folder_id ?? rootFolder.id;

  let actions = {};

  const fillActions = (folder) => {
    if (folder.deleted) {
      return;
    }

    const parents = getParents(foldersById, folder.id);

    const isDisabled = folder.id === folderId || (!isProject && (folder.id === parentFolderId || parents.some((parent) => parent.id === folderId)));

    const onClick = () => {
      onMoveToFolder(folder.id);
    };

    const getSrc = (folder) => {
      if (folder.parent_folder_id === null) {
        return "/assets/home.svg";
      } else if (folder.series_id) {
        return "/assets/series.svg";
      } else {
        return "/assets/folder2.svg";
      }
    };

    actions[folder.id] = {
      label: folder.title,
      nesting: parents.length,
      onClick: isDisabled ? undefined : onClick,
      icon: (
        <SVG
          width={24}
          height={24}
          src={getSrc(folder)}
          className="folder"
          aria-hidden="true"
        />
      ),
    };

    foldersByParentId[folder.id]?.forEach((child) => {
      fillActions(child);
    });
  };

  fillActions(rootFolder);

  return actions;
}
